import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }

  public user: string;
  public pass: string;
  public nome: string;
  // Utilizado para Debug e para o build para Browser (true = browser / false = mobiler)
  public debugMode = false;
  public loginList: any;
  public dominio: string;
  public plano;

}
